export default "/images/company1.png?85f775a01d5f280ddc841e8778a47137";